// extracted by mini-css-extract-plugin
export var labelWrapper = "_md-0";